import api from "../api";

const generateHtml = (data) => {
  return api.getApi().post(api.getBaseUrl() + "ai/generate-html", data);
};

export { generateHtml };
